import { Badge, Dropdown, MenuProps, Popover } from "antd";
import SearchInput from "components/Desktop/SearchInput";
import UserMenu from "components/Desktop/UserMenu";
import useLoginModal from "hooks/useLoginModal";
import CartFillIcon from "icons/CartFillIcon";
import PersonIcon from "icons/PersonIcon";
import { Menu } from "lucide-react";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetCart } from "services/cart";
import useUserStore from "stores/user";
import { useQueryClient } from "@tanstack/react-query";

// const menuList = [
//   {
//     label: "สินค้าทั้งหมด",
//     link: "/",
//   },
//   {
//     label: "เงื่อนไขการเปลี่ยนคืนสินค้า",
//     link: "/return-policy",
//   },
//   {
//     label: "รายการสั่งซื้อ",
//     link: "/setting/order-history",
//   },
// ];
const MobileHeader = () => {
  const isMobile = useMediaQuery({
    query: "(max-width: 576px)",
  });
  const { pathname } = useLocation();
  const { user } = useUserStore();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Call useGetCart with the user parameter to enable/disable the query
  const { cartItemList = [] } = useGetCart(user);

  const [openUserMenu, setUserMenuOpen] = useState<boolean>(false);

  const { loginModal, showLogin } = useLoginModal();
  const handleUserMenuChange = (newOpen: boolean) => {
    setUserMenuOpen(newOpen);
  };

  // const [isOpenPaymentNotiModal, setIsOpenPaymentNotiModal] =
  //   useState<boolean>(false);

  const onLogoutCallback = () => {
    setUserMenuOpen(false);
    // queryClient.invalidateQueries({
    //   queryKey: ["getProduct"],
    // });
  };

  const handleClickLogin = () => {
    showLogin();
  };

  const handleLogoClick = () => {
    if (pathname === "/") {
      // If already on home page, refetch product data
      queryClient.invalidateQueries({
        queryKey: ["getProduct"],
      });
    } else {
      // If on other pages, navigate to home
      navigate("/");
    }
  };

  // const onClosePaymentModal = () => {
  //   setIsOpenPaymentNotiModal(false);
  // };

  // const handleOnClickUpdatePaymentButton = () => {
  //   if (user) {
  //     setIsOpenPaymentNotiModal(true);
  //   } else {
  //     showLogin();
  //   }
  // };
  const items: MenuProps["items"] = [
    {
      label: "สินค้าทั้งหมด",
      key: "0",
      onClick: () => {
        navigate("/");
      },
    },
    {
      label: "แลกคะแนน",
      key: "1",
      onClick: () => {
        navigate("/capsule-market");
      },
    },
    {
      label: "เงื่อนไขการเปลี่ยนคืนสินค้า",
      key: "2",
      onClick: () => {
        navigate("/return-policy");
      },
    },
    {
      label: "รายการสั่งซื้อ",
      key: "3",
      onClick: () => {
        navigate("/setting/order-history");
      },
    },
  ];
  return (
    <header className="h-[85px] flex items-center bg-white pl-4 pr-2 gap-3 justify-between">
      <div className="flex gap-4 items-center">
        <div className="cursor-pointer" onClick={handleLogoClick}>
          <div className="flex">
            <img
              className="my-auto mr-4"
              src="/logo.png"
              width={50}
              height={50}
            />
            <div className="flex flex-col justify-center">
              {!isMobile && (
                <>
                  <div>
                    <span className="font-semibold mr-2">นรินทร์เภสัช</span>
                    <small>ชัยภูมิ</small>
                  </div>
                  <div>NARINONLINE</div>
                </>
              )}
            </div>
          </div>
        </div>
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          className="cursor-pointer"
          overlayClassName="mt-5"
        >
          <Menu className="text-primary-700" />
        </Dropdown>
      </div>
      <div style={{ width: "55%" }}>
        <SearchInput width="100%" />
      </div>
      <div className="flex gap-4 items-center">
        <div
          className="hover:cursor-pointer"
          onClick={() => {
            navigate("/cart");
          }}
        >
          <Badge count={cartItemList?.length} color="#9F341F">
            <CartFillIcon />
          </Badge>
        </div>
        {user ? (
          <Popover
            content={<UserMenu callback={onLogoutCallback} />}
            trigger="click"
            open={openUserMenu}
            onOpenChange={handleUserMenuChange}
            placement="bottom"
            overlayInnerStyle={{ padding: 0 }}
            className="cursor-pointer"
          >
            <div className="bg-primary-300 rounded-full w-8 h-8 text-center flex justify-center items-center">
              <PersonIcon className="text-primary" />
            </div>
          </Popover>
        ) : (
          <div
            className="bg-primary-300 rounded-full w-8 h-8 text-center flex justify-center items-center cursor-pointer"
            onClick={handleClickLogin}
          >
            <PersonIcon className="text-primary" />
          </div>
        )}
      </div>

      {loginModal}
    </header>
  );
};

export default MobileHeader;
